export enum LevelTestType {
  END_OF_LEVEL = 'END_OF_LEVEL',
  MID_LEVEL = 'MID_LEVEL',
}

export enum LevelTestStatus {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
}
